import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=583c7ca6&scoped=true&"
import script from "./MetricItem.vue?vue&type=script&lang=js&"
export * from "./MetricItem.vue?vue&type=script&lang=js&"
import style0 from "./MetricItem.vue?vue&type=style&index=0&id=583c7ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c7ca6",
  null
  
)

export default component.exports